import React from "react";
import classnames from "classnames";
import ReactSwitch from "react-switch";
import ConsultSvgIcon from "@components/Common/SvgIcons/ConsultSvgIcon";
import {
    EyeIcon,
    HeartIcon,
    PencilIcon,
    TrashIcon,
} from "@aureskonnect/react-ui";
import { Tooltip } from "@mui/material";
import TimePastSvgIcon from "@components/Common/SvgIcons/TimePastSvgIcon";
import { GetSalesModesTypesAndTagsV2 } from "@pages/SettingGeneral/ModeOfSale/ModeOfSales/helper";
import { useSnapshot } from "valtio";
import { store as useStore } from "../../../../components/VerticalLayout/store";
import { useFetchGlobal } from "../../../../api/hooks";

const SaleSupportActions = ({
    modify,
    isEdited,
    isArchivedSaleSupportClicked,
    isLoading,
    oneShop,
    selectedRowData,
    saleSupportState,
    dataArchive,
    listFranchiseArchived,
    isActionsClicked,
    isInputUpdated,
    isModalConfirmationOpened,
    isHistoryModalOpened,
    t,
    setIsActionsClicked,
    setActions,
    setIsEdited,
    setSaleSupport,
    setIsAddSaleSupportClicked,
    setIsInputUpdated,
    setIsConsult,
    setIsLoading,
    setRowData,
    favoriteSaleSupport,
    ErrorToast,
    setSaleSupportState,
    handleStateChange,
    setDataState,
    setMessage,
    setYesFunction,
    setActivationDeactivationMessageModalOpened,
    setSaleSupportToBeArchived,
    handleTrashButtonClicked,
    setSelectedRows,
    setIsModalConfirmationOpened,
    handleActiveSaleSupport,
    setIsHistoryModalOpened,
    setSelectedSaleSupports,
    setSelectedHistorySaleSupports,
    setSalesModesTypesAndTag,
}: any) => {
    const { fetchGlobal } = useFetchGlobal();
    const { franchiseID, shopID } = useSnapshot(useStore);
    const shopId = oneShop ? shopID : 0;
    const handleConsultClick = () => {
        if (isEdited === true) {
            setIsActionsClicked(!isActionsClicked);
            setActions(() => {
                setIsEdited(false);
                setSaleSupport(selectedRowData.selectedRow);
                setIsAddSaleSupportClicked(true);
                setIsInputUpdated(!isInputUpdated);
            });
        } else {
            setSaleSupport(selectedRowData.selectedRow);
            setIsAddSaleSupportClicked(true);
            setIsInputUpdated(!isInputUpdated);
        }
        setIsConsult(true);
    };
    const handleAddSalesMethodClick = async () => {
        try {
            const configs = await GetSalesModesTypesAndTagsV2(
                franchiseID,
                shopId,
                fetchGlobal
            );
            const data = configs[0];

            if (!data) return;

            setSalesModesTypesAndTag(data);
        } catch (error) {
            console.error("Error fetching sales modes and tags:", error);
        }
    };
    const handleEditClick = async () => {
        await handleAddSalesMethodClick();
        if (isEdited === true) {
            setIsActionsClicked(!isActionsClicked);
            setActions(() => {
                setIsEdited(false);
                setSaleSupport(selectedRowData.selectedRow);
                setIsAddSaleSupportClicked(true);
                setIsInputUpdated(!isInputUpdated);
            });
        } else {
            setSaleSupport(selectedRowData.selectedRow);
            setIsAddSaleSupportClicked(true);
            setIsInputUpdated(!isInputUpdated);
        }
    };

    const handleFavoriteClick = () => {
        if (selectedRowData.selectedRow.isFavorite === false) {
            setIsLoading(true);
            if (isEdited === true) {
                setIsLoading(false);
                setIsActionsClicked(!isActionsClicked);
                setActions(() => {
                    setIsEdited(false);
                    setIsAddSaleSupportClicked(false);
                    if (
                        selectedRowData.selectedRow.isActive === false &&
                        oneShop &&
                        selectedRowData.selectedRow.isFavorite === false
                    ) {
                        ErrorToast(
                            t(
                                "Please note, you cannot activate the favorite state for a disabled sale support"
                            )
                        );
                    } else {
                        setRowData(selectedRowData.selectedRow);
                        favoriteSaleSupport(selectedRowData);
                    }
                });
            } else {
                if (
                    selectedRowData.selectedRow.isActive === false &&
                    oneShop &&
                    selectedRowData.selectedRow.isFavorite === false
                ) {
                    setIsLoading(false);
                    ErrorToast(
                        t(
                            "Please note, you cannot activate the favorite state for a disabled sale support"
                        )
                    );
                } else {
                    setRowData(selectedRowData.selectedRow);
                    favoriteSaleSupport(selectedRowData);
                }
            }
        }
    };

    const handleSwitchChange = async (e: boolean) => {
        if (isEdited === true) {
            setIsActionsClicked(!isActionsClicked);
            setActions(() => {
                if (selectedRowData.selectedRow.isFavorite) {
                    ErrorToast(
                        t(
                            "Please note, you cannot deactivate a favorite sale support"
                        )
                    );
                } else {
                    setIsEdited(false);
                    setIsAddSaleSupportClicked(false);
                    setMessage(
                        saleSupportState
                            ? t(
                                  "Caution, the Sale support may be used by other modules.\n Would you like to confirm the deactivation of the selected Sale support?"
                              )
                            : t(
                                  "Would you like to confirm the activation of the selected Sale support?"
                              )
                    );
                    setYesFunction(() => {
                        setSaleSupportState(!saleSupportState);
                        handleStateChange(e);
                        setDataState({
                            id: selectedRowData.selectedRow.Id,
                            state: !saleSupportState,
                        });
                    });
                    setActivationDeactivationMessageModalOpened(true);
                }
            });
        } else {
            if (selectedRowData.selectedRow.isFavorite) {
                ErrorToast(
                    t(
                        "Please note, you cannot deactivate a favorite sale support"
                    )
                );
            } else {
                setIsAddSaleSupportClicked(false);
                setMessage(
                    saleSupportState
                        ? t(
                              "Caution, the Sale support may be used by other modules.\n Would you like to confirm the deactivation of the selected Sale support?"
                          )
                        : t(
                              "Would you like to confirm the activation of the selected Sale support?"
                          )
                );
                setYesFunction(() => {
                    setIsLoading(true);
                    setSaleSupportState(!saleSupportState);
                    handleStateChange(e);
                    setDataState({
                        id: selectedRowData.selectedRow.Id,
                        state: !saleSupportState,
                    });
                });
                setActivationDeactivationMessageModalOpened(true);
            }
        }
    };

    const handleArchiveClick = async () => {
        setIsLoading(true);
        if (isEdited === true) {
            if (selectedRowData.selectedRow?.isFavorite === true) {
                setIsLoading(false);
                ErrorToast(
                    t(
                        "Please note, you cannot archive a favorite sales support"
                    )
                );
            } else {
                setIsLoading(false);
                setIsActionsClicked(!isActionsClicked);
                setActions(async () => {
                    setIsEdited(false);
                    setSaleSupportToBeArchived(selectedRowData.selectedRow);
                    await handleTrashButtonClicked(selectedRowData.selectedRow);
                    setIsAddSaleSupportClicked(false);
                });
            }
        } else {
            if (selectedRowData.selectedRow?.isFavorite === true) {
                setIsLoading(false);
                ErrorToast(
                    t(
                        "Please note, you cannot archive a favorite sales support"
                    )
                );
            } else {
                setIsLoading(false);
                setIsAddSaleSupportClicked(false);
                setSaleSupportToBeArchived(selectedRowData.selectedRow);
                await handleTrashButtonClicked(selectedRowData.selectedRow);
            }
        }
    };

    const handleUnarchiveClick = () => {
        setIsLoading(true);
        setSelectedRows([selectedRowData.selectedRow]);
        if (dataArchive.includes(selectedRowData.selectedRow.Id) && !oneShop) {
            setIsModalConfirmationOpened(!isModalConfirmationOpened);
            setIsLoading(false);
        } else {
            handleActiveSaleSupport(selectedRowData);
        }
    };

    const handleHistoryClick = () => {
        if (isEdited === true) {
            setIsActionsClicked(!isActionsClicked);
            setActions(() => {
                setIsEdited(false);
                setIsHistoryModalOpened(!isHistoryModalOpened);
                setSelectedSaleSupports([
                    {
                        [selectedRowData.selectedRow.shopId]:
                            selectedRowData.selectedRow.Id,
                    },
                ]);
                setSelectedHistorySaleSupports(selectedRowData.selectedRow);
                setIsAddSaleSupportClicked(false);
            });
        } else {
            setIsAddSaleSupportClicked(false);
            setIsHistoryModalOpened(!isHistoryModalOpened);
            setSelectedSaleSupports([
                {
                    [selectedRowData.selectedRow.shopId]:
                        selectedRowData.selectedRow.Id,
                },
            ]);
            setSelectedHistorySaleSupports(selectedRowData.selectedRow);
        }
    };

    return (
        <>
            {modify === false ? (
                <Tooltip title={t("To consult")}>
                    <div>
                        <ConsultSvgIcon
                            className="pointer__clz afa_icn_toConsult"
                            height={35}
                            width={35}
                            style={{
                                cursor: "pointer",
                                position: "relative",
                                bottom: "5px",
                            }}
                            fill="black"
                            onClick={handleConsultClick}
                        />
                    </div>
                </Tooltip>
            ) : null}

            {modify === true ? (
                <>
                    <Tooltip
                        title={
                            isArchivedSaleSupportClicked
                                ? ""
                                : selectedRowData.selectedRow.isFavorite ===
                                  false
                                ? t("Enable favorite state")
                                : ""
                        }
                    >
                        <div>
                            <HeartIcon
                                onClick={handleFavoriteClick}
                                height={25}
                                width={25}
                                name="heart"
                                fill={
                                    selectedRowData.selectedRow.isFavorite
                                        ? "red"
                                        : "black"
                                }
                                className={classnames(
                                    {
                                        pointer__clz: !selectedRowData
                                            .selectedRow.isFavorite,
                                    },
                                    {
                                        "not-allowed-icon__clz":
                                            isArchivedSaleSupportClicked ||
                                            isLoading,
                                    },
                                    oneShop ? "mr-2" : ""
                                )}
                            />
                        </div>
                    </Tooltip>

                    <Tooltip
                        title={isArchivedSaleSupportClicked ? "" : t("Edit")}
                    >
                        <div>
                            <PencilIcon
                                onClick={handleEditClick}
                                height={25}
                                width={25}
                                style={{ cursor: "pointer" }}
                                className={classnames(
                                    "pointer__clz cmn_icn_FRedit",
                                    {
                                        "not-allowed-icon__clz":
                                            isArchivedSaleSupportClicked ||
                                            isLoading,
                                    },
                                    oneShop ? "mr-2" : "ml-3"
                                )}
                            />
                        </div>
                    </Tooltip>

                    {oneShop ? (
                        <Tooltip
                            title={
                                isArchivedSaleSupportClicked
                                    ? ""
                                    : saleSupportState === false
                                    ? t("Activate")
                                    : t("Unactivate")
                            }
                        >
                            <div>
                                <ReactSwitch
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    handleDiameter={26}
                                    offColor="#f7b4b8"
                                    offHandleColor="#E30613"
                                    checked={saleSupportState}
                                    onChange={handleSwitchChange}
                                    onColor="#c2eddd"
                                    onHandleColor="#34C38F"
                                    width={50}
                                    height={20}
                                    className={classnames(
                                        "sdv_icn_FRiconEnableDisable sdv_icn_AFselectorActiveDeactivate sdv_icn_BTiconEnableDisable",
                                        {
                                            "not-allowed-icon__clz":
                                                isArchivedSaleSupportClicked ||
                                                isLoading,
                                        },
                                        oneShop ? "mr-2" : "ml-3"
                                    )}
                                />
                            </div>
                        </Tooltip>
                    ) : null}

                    {!isArchivedSaleSupportClicked ? (
                        <Tooltip title={t("Archive")}>
                            <div>
                                <TrashIcon
                                    onClick={handleArchiveClick}
                                    height={25}
                                    width={25}
                                    fill="red"
                                    style={{ cursor: "pointer" }}
                                    className={classnames(
                                        "pointer__clz cmn_icn_FRarchived",
                                        {
                                            "not-allowed-icon__clz":
                                                isArchivedSaleSupportClicked ||
                                                isLoading,
                                        },
                                        oneShop ? "mr-2" : "ml-3"
                                    )}
                                />
                            </div>
                        </Tooltip>
                    ) : (
                        <Tooltip title={t("Unarchived")}>
                            <div>
                                <EyeIcon
                                    height={25}
                                    width={25}
                                    style={{ cursor: "pointer" }}
                                    onClick={handleUnarchiveClick}
                                    className={classnames(
                                        "pointer__clz cmn_icn_FRunarchive",
                                        {
                                            "not-allowed-icon__clz":
                                                isLoading ||
                                                (shopID !== "0" &&
                                                    listFranchiseArchived.find(
                                                        (el: any) =>
                                                            el.Id ===
                                                            selectedRowData
                                                                .selectedRow.Id
                                                    ) !== undefined),
                                        },
                                        oneShop ? "mr-2" : "ml-3"
                                    )}
                                />
                            </div>
                        </Tooltip>
                    )}
                </>
            ) : null}

            <Tooltip title={t("Consult history")}>
                <div>
                    <TimePastSvgIcon
                        onClick={handleHistoryClick}
                        className={classnames(
                            "pointer__clz cmn_icn_FRhistory",
                            oneShop ? "mr-2" : "ml-3"
                        )}
                    />
                </div>
            </Tooltip>
        </>
    );
};

export default SaleSupportActions;
